import { UserRoleType } from '~/enums/UserRoleType';
import { Permission } from '~/types/Permission';
import { testIsSuperAdmin } from '~/utils/user';

import { or } from './utils/or';
import { testHasRole } from './utils/testHasRole';

export const checkIsAdmin: Permission = or([
  testIsSuperAdmin,
  testHasRole(UserRoleType.Admin),
]);
